__turbopack_context__.v({
  "className": "inter_e341d613-module__HZ75va__className",
});
